import {
  Box,
  Grid,
  makeStyles,
  Paper,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  withStyles,
  Typography,
} from "@material-ui/core";
import { useState, useEffect } from "react";
import clsx from "clsx";
import FlightIcon from "@material-ui/icons/Flight";
import CreateIcon from "@material-ui/icons/Create";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { AutocompleteInput, Loading } from "react-admin";
import { useAppDataProvider } from "../../../../dataprovider";
import { useAuth, useVerifyPermission } from "@airborne/react-admin";
import React from "react";
import { Form } from "react-final-form";
import { ModelState } from "../../Models/ModelStateEnum";
import { RequestType } from "../../../../Enums/RequestType";
import PbhRequestOrderInfo from "../PbhInfo/PbhRequestOrderInfo";
import RbhRequestOrderInfo from "../Info/RbhRequestOrderInfo";

//#region stepper const material
const steps = ["Select Aircraft", "Create Request"];
const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    "& $line": {
      backgroundImage: "linear-gradient( 95deg,rgb(255,255,255) 0%,rgb(160,160,160) 50%,rgb(200,12,15) 100%)",
    },
  },
  completed: {
    "& $line": {
      backgroundImage: "linear-gradient( 95deg,rgb(255,255,255) 0%,rgb(160,160,160) 50%,rgb(200,12,15) 100%)",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 50,
    height: 50,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  active: {
    backgroundImage: "linear-gradient( 136deg, rgb(255,255,255) 0%, rgb(200,12,15) 50%, rgb(255,255,255) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.1)",
  },
  completed: {
    backgroundImage: "linear-gradient( 136deg, rgb(255,255,255) 0%, rgb(200,12,15) 50%, rgb(255,255,255) 100%)",
  },
});

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));
//#endregion

const RequestOrderCreateCondition = props => {
  useVerifyPermission("customroutes", "requestorders.condition.read");
  const { user } = useAuth();
  const [loading, setLoading] = React.useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const classes = useStyles();
  const dataProvider = useAppDataProvider();
  const [acRegList, setAcRegList] = useState([] as any);
  const [data, setData] = React.useState(null as any);
  const [selectedAircraft, setSelectedAircraft] = React.useState(null as any);

  //#region stepper
  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  function ColorlibStepIcon(props) {
    const classes = useColorlibStepIconStyles();
    const { active, completed } = props;

    const icons = {
      1: <FlightIcon />,
      2: <CreateIcon />,
    };

    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
          [classes.completed]: completed,
        })}
      >
        {icons[String(props.icon)]}
      </div>
    );
  }
  //#endregion

  //#region events
  const aircraftChangeEvent = e => {
    let aircraftId = e;
    let selectedAircraft = acRegList.filter(ac => ac.id == aircraftId)[0];
    setSelectedAircraft(selectedAircraft);
  };
  //#endregion

  //#region useEffects
  useEffect(() => {
    if (user?.isActive && selectedAircraft !== undefined && selectedAircraft !== null) {
      LoadNewRequestData();
    }
  }, [selectedAircraft, user?.isActive]);

  useEffect(() => {
    if (user?.isActive) {
      GetAircraftList();
    }
  }, [user?.ownerCode, user?.isActive]);
  //#endregion

  //#region Requests
  const GetAircraftList = async () => {
    setLoading(false);
    dataProvider
      .getList("cdmaircraft/FetchAcListAsync/" + user?.ownerCode, {
        pagination: { page: 1, perPage: 9999 },
        sort: { field: "id", order: "DESC" },
        filter: { isAircraftStatus__eq: true, isContractStatus__eq: true },
      })
      .then(response => {
        let dataLength: number = response.data.length;
        setAcRegList([]);
        if (dataLength > 0) {
          let data = response.data;
          setAcRegList(data);
        }
      })
      .catch(error => {});
  };

  const LoadNewRequestData = async () => {
    setLoading(true);

    dataProvider
      .getNewRequestData(selectedAircraft.acReg)
      .then((response: any) => {
        if (response.data !== null && response.data !== undefined) {
          setData(response?.data);
          setLoading(false);
          handleNext();
        }
      })
      .catch(error => {
        setLoading(false);
      });
  };
  //#endregion

  // Check if user is not active
  if (!user?.isActive) {
    return (
      <div className={classes.root}>
        <Grid container spacing={3} justifyContent="center" alignItems="center" style={{ minHeight: "60vh" }}>
          <Grid item xs={12} sm={8} md={6}>
            <Paper elevation={3} style={{ padding: "48px 32px", textAlign: "center" }}>
              <InfoOutlinedIcon style={{ fontSize: 80, color: "#c80c0f", marginBottom: "24px" }} />
              <Typography variant="h4" style={{ color: "#c80c0f", fontWeight: 600, marginBottom: "16px" }}>
                Contract Status Required
              </Typography>
              <Typography variant="body1" style={{ color: "#666", fontSize: "18px", lineHeight: "1.6" }}>
                Please check the status of your contract.
              </Typography>
              <Typography variant="body2" style={{ color: "#999", marginTop: "24px", fontSize: "14px" }}>
                Your account is currently inactive. Please contact your administrator for assistance.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <Grid item container spacing={3}>
        <>
          <Grid item xs={3}></Grid>
          <Grid item xs={6} direction="row" justifyContent="center" alignItems="center">
            <Paper className={classes.paper} style={{ color: "#c80c0f", fontWeight: 500 }}>
              Make New Request
            </Paper>
          </Grid>
          <Grid item xs={3}></Grid>
        </>
        <>
          <Grid item xs={1}></Grid>
          <Grid item xs={10} direction="row" justifyContent="center" alignItems="center">
            <Paper>
              <Box>
                <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                  {steps.map(label => (
                    <Step key={label}>
                      <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </Box>

              {/* <Paper> */}
              <div style={{ display: "grid", justifyContent: "center" }}>
                <Form
                  onSubmit={() => {}}
                  render={({ handleSubmit, form, values }) => {
                    return (
                      <AutocompleteInput
                        source="aircraftId"
                        choices={acRegList}
                        optionText="acReg"
                        optionValue="id"
                        onChange={aircraftChangeEvent}
                        fullWidth
                        variant="outlined"
                        required
                        style={{ minWidth: "600px", marginBottom: "30px" }}
                      />
                    );
                  }}
                />
              </div>
            </Paper>
          </Grid>
          <Grid item xs={1}></Grid>
        </>
        {((selectedAircraft !== null && selectedAircraft !== undefined && data !== null && data !== undefined) ||
          loading) && (
          <>
            <Grid item xs={1}></Grid>
            <Grid item xs={10} direction="row" justifyContent="center" alignItems="center">
              <Paper>
                {loading === false ? (
                  data?.requestType === RequestType.RBH ? (
                    <RbhRequestOrderInfo ModelState={ModelState.Create} selectedData={data} />
                  ) : (
                    <PbhRequestOrderInfo ModelState={ModelState.Create} selectedData={data} />
                  )
                ) : (
                  <div style={{ padding: 4 }}>
                    <Loading loadingPrimary={"Please Wait!"} loadingSecondary={"This process may take a few seconds"} />
                  </div>
                )}
              </Paper>
            </Grid>
            <Grid item xs={1}></Grid>
          </>
        )}
      </Grid>
    </div>
  );
};

export default RequestOrderCreateCondition;
